import { useEffect } from "react";

import { useRouter } from "next/router";

import { useIOSLimitations } from "shared/hooks/useIOSLimitations";

export const useLimitAcessInPagesByIOSLimitations = () => {
  const { asPath, push } = useRouter();
  const { shouldEnableIOSLimitations } = useIOSLimitations();

  const pagesWithAcess = [
    "/browse",
    "/classwork",
    "/401",
    "/404",
    "/custom-not-found",
    "/moderation",
    "/reset",
  ];

  useEffect(() => {
    if (!shouldEnableIOSLimitations) return;

    const isPageWithAccess = pagesWithAcess.some((page) =>
      asPath?.includes(page),
    );

    if (!isPageWithAccess) push("/browse");
  }, [shouldEnableIOSLimitations, asPath]);

  return null;
};
